import React, { useState, useEffect } from "react";
import PageTitle from "../../../../common/PageTitle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  Box,
  Button,
  Grid,
  Modal,
  Paper,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
} from "@mui/material";

import { getAPI, deleteAPI, postAPI, putAPI } from "../../../../network"; // Assuming you have these functions to make API requests.

const AddFaultType = () => {
  let companyId = localStorage.getItem("companyIdLS");
  if (companyId === null) {
    companyId = undefined;
  }
  const [modalOpen, setModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [faultTypeList, setFaultTypeList] = useState([]);
  const [inputs, setInputs] = useState({ title: "", issueType: "", companyId, file: null });
  const [issueTypes, setIssueTypes] = useState([]);
  const [editInputs, setEditInputs] = useState({
    _id: "",
    title: "",
    issueType: "",
    companyId,
    file: null,
  });

  // Fetch Fault Types
  const getFaultTypes = async () => {
    try {
      const response = await getAPI(
        `/building/get-fault?companyId=${companyId}`
      );

      if (response) {
        setFaultTypeList(response);
      }
    } catch (error) {
      console.error("Error fetching fault types:", error);
    }
  };

  const getIssueType = async () => {
    try {
      const response = await getAPI(
        `/building/get-issuetype?companyId=${companyId}`
      );
      if (response) {
        setIssueTypes(response);
      }
    } catch (error) {
      console.error("Error fetching issue types:", error);
    }
  };

  // Delete Fault Type
  const deleteFaultType = async (id) => {
    try {
      const response = await deleteAPI(`/building/delete-fault/${id}`);
      if (response) {
        getFaultTypes(); // Refresh the list after deletion
      }
    } catch (error) {
      console.error("Error deleting fault type:", error);
    }
  };

  // Handle Add Fault Type with FormData
  const handleAddFaultType = async () => {
    try {
      const formData = new FormData();
      formData.append("title", inputs.title);
      formData.append("issueType", inputs.issueType);
      formData.append("companyId", inputs.companyId);
      if (inputs.file) {
        formData.append("picture", inputs.file);
      }

      // API call to create a new fault type
      const response = await postAPI("/building/create-fault", formData);

      if (response) {
        setModalOpen(false); // Close the modal
        // Clear file input after submission
        setInputs({ title: "", issueType: "", companyId, file: null });
        getFaultTypes(); // Refresh fault types list
      }
    } catch (error) {
      console.error("Error adding fault type:", error);
    }
  };

  // Handle Edit Fault Type with FormData
  const handleEditFaultType = async () => {
    try {
      const formData = new FormData();
      formData.append("title", editInputs.title);
      formData.append("issueType", editInputs.issueType);
      formData.append("companyId", editInputs.companyId);
      // Optionally append file if user selected one
      if (editInputs.file) {
        formData.append("picture", editInputs.file);
      }

      const response = await putAPI(`/building/update-fault/${editInputs._id}`, formData);

      if (response) {
        setEditModal(false); // Close the modal
        // Clear file input after submission
        setEditInputs({ _id: "", title: "", issueType: "", companyId, file: null });
        getFaultTypes(); // Refresh fault types list
      }
    } catch (error) {
      console.error("Error updating fault type:", error);
    }
  };

  // Handle input changes for Add Fault Type
  const handleInputChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
  };

  // Handle file change for Add Fault Type
  const handleFileAddChange = (e) => {
    setInputs({ ...inputs, file: e.target.files[0] });
  };

  // Handle input changes for Edit Fault Type
  const handleEditChange = (e) => {
    setEditInputs({ ...editInputs, [e.target.name]: e.target.value });
  };

  // Handle file change for Edit Fault Type
  const handleFileEditChange = (e) => {
    setEditInputs({ ...editInputs, file: e.target.files[0] });
  };

  useEffect(() => {
    getFaultTypes();
    getIssueType();
  }, []);

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 500,
    bgcolor: "background.paper",
    border: "2px solid #fff",
    borderRadius: "5px",
    boxShadow: 24,
    p: 4,
  };
  const [page, setPage] = useState(0);
  const [perPages, setPerPages] = useState([10, 25, 50, 100]);
  const [perPage, setPerPage] = useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <Grid>
      <PageTitle title={"Fault Type"} />
      <Grid>
        <Button
          onClick={() => setModalOpen(true)}
          variant="contained"
          style={{ backgroundColor: "#75859D", float: "right" }}
          sx={{ height: 52, mx: 2 }}
        >
          <AddCircleIcon /> &nbsp; Add Fault Type
        </Button>
      </Grid>

      <Grid style={{ marginTop: "50px" }}>
        <TableContainer
          component={Paper}
          sx={{ mx: "0.8rem", width: "60%", my: "6rem" }}
        >
          <Table
            sx={{ minWidth: "auto" }}
            aria-label="custom pagination table"
            className="responsive-table"
          >
            <TableHead>
              <TableRow className="table-header">
                <TableCell align="left">Issue Type</TableCell>
                <TableCell align="left">Fault Type</TableCell>
                <TableCell align="left">File</TableCell>
                <TableCell align="left">Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {faultTypeList
                ?.reverse()
                .slice(page * perPage, page * perPage + perPage)
                .map((item) => (
                  <TableRow key={item._id}>
                    <TableCell align="left">{item.issueType?.title}</TableCell>
                    <TableCell align="left">{item.title}</TableCell>
                    <TableCell align="left">
                      {item.fileUrl ? (
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => window.open(item.fileUrl, "_blank")}
                        >
                          Open File
                        </Button>
                      ) : (
                        "No File"
                      )}
                    </TableCell>
                    <TableCell align="left">
                      <Button
                        size="small"
                        variant="outlined"
                        color="info"
                        onClick={() => {
                          setEditModal(true);
                          setEditInputs({
                            title: item.title,
                            issueType: item.issueType?._id,
                            _id: item._id,
                            companyId,
                            file: null,
                          });
                        }}
                      >
                        <EditIcon />
                      </Button>
                      <Button
                        size="small"
                        variant="outlined"
                        color="error"
                        style={{ marginLeft: "8px" }}
                        onClick={() => deleteFaultType(item._id)}
                      >
                        <DeleteIcon />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  align="right"
                  rowsPerPageOptions={perPages}
                  colSpan={9}
                  count={faultTypeList.length}
                  rowsPerPage={perPage}
                  page={page}
                  SelectProps={{
                    inputProps: {
                      "aria-label": "rows per page",
                    },
                    native: true,
                  }}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </TableContainer>
      </Grid>

      {/* Add Modal */}
      <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
        <Box sx={style}>
          <PageTitle title={"Add Fault Type"} />
          <FormControl fullWidth style={{ marginBottom: "15px" }}>
            <InputLabel>Issue Type</InputLabel>
            <Select
              name="issueType"
              value={inputs.issueType}
              onChange={handleInputChange}
              label="Issue Type"
            >
              {issueTypes.map((issueType) => (
                <MenuItem key={issueType._id} value={issueType._id}>
                  {issueType.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Enter Fault Type Name"
            variant="outlined"
            fullWidth
            name="title"
            value={inputs.title}
            onChange={handleInputChange}
            style={{ marginBottom: "15px" }}
          />

          {/* File Upload Input */}
          <Button variant="outlined" component="label" fullWidth sx={{ marginBottom: "15px" }}>
            {inputs.file ? inputs.file.name : "Upload File"}
            <input
              type="file"
              name="file"
              hidden
              onChange={handleFileAddChange}
              accept="*"
            />
          </Button>

          <Grid container justifyContent="flex-end" spacing={2}>
            <Grid item>
              <Button
                variant="contained"
                onClick={handleAddFaultType}
                sx={{ height: 40 }}
              >
                Submit
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => setModalOpen(false)}
                sx={{ height: 40 }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      {/* Edit Modal */}
      <Modal open={editModal} onClose={() => setEditModal(false)}>
        <Box sx={style}>
          <PageTitle title={"Update Fault Type"} />
          <FormControl fullWidth style={{ marginBottom: "15px" }}>
            <InputLabel>Issue Type</InputLabel>
            <Select
              name="issueType"
              value={editInputs.issueType}
              onChange={handleEditChange}
              label="Issue Type"
            >
              {issueTypes.map((issueType) => (
                <MenuItem key={issueType._id} value={issueType._id}>
                  {issueType.title}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <TextField
            label="Edit Fault Type Name"
            variant="outlined"
            fullWidth
            name="title"
            value={editInputs.title}
            onChange={handleEditChange}
            style={{ marginBottom: "15px" }}
          />

          {/* File Upload Input for Edit */}
          <Button variant="outlined" component="label" fullWidth sx={{ marginBottom: "15px" }}>
            {editInputs.file ? editInputs.file.name : "Upload New File (optional)"}
            <input
              type="file"
              name="file"
              hidden
              onChange={handleFileEditChange}
              accept="*"
            />
          </Button>

          <Grid container justifyContent="flex-end" spacing={2}>
            <Grid item>
              <Button
                variant="contained"
                onClick={handleEditFaultType}
                sx={{ height: 40 }}
              >
                Update
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                onClick={() => setEditModal(false)}
                sx={{ height: 40 }}
              >
                Cancel
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Modal>
    </Grid>
  );
};

export default AddFaultType;
